import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { PortalLayout } from "../../components/PortalLayout";
import { clientApi } from "../../lib/client-api";
import { browserLanguage, portalText } from "../../lib/i18n";

/**
 * Landing for links in emails. `kind="magic"` (/acceso) opens the quote list;
 * `kind="quote"` (/ver) opens the quote the email was about.
 */
export function RedeemLink({ kind }: { kind: "magic" | "quote" }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const started = useRef(false);
  const text = portalText(browserLanguage());

  useEffect(() => {
    // Magic links are single use: never redeem twice (React StrictMode runs effects twice in dev).
    if (started.current) return;
    started.current = true;
    const token = params.get("token") ?? "";
    const redeem =
      kind === "magic"
        ? clientApi.redeemMagicLink(token).then(() => "/cotizaciones")
        : clientApi.redeemQuoteLink(token).then((r) => `/cotizaciones/${r.quoteId}`);
    redeem.then((to) => navigate(to, { replace: true })).catch(() => setFailed(true));
  }, [kind, navigate, params]);

  return (
    <PortalLayout>
      <section className="card narrow-card">
        {failed ? (
          <>
            <p className="error">{text.invalidLink}</p>
            <Link to="/">{text.requestNew}</Link>
          </>
        ) : (
          <p className="muted">{text.verifying}</p>
        )}
      </section>
    </PortalLayout>
  );
}
